<template>
    <div class="g-module-box">
		<div class="g-module" :class="flex">
			<slot></slot>
		</div>
		<div v-if="$slots.button" class="flex-center g-module-button">
			<slot name="button"></slot>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			flex: String
		}
	}
</script>

<style lang="stylus" scoped>
	.g-module {
		width: 1200px;
		height: 100%;
		margin: 0 auto;
		
		&-box {
			background: #fff;
		
			&:after {
				content: '';
				display: block;
				height: .1px;
			}
		}
	
		&-button {
			z-index: 99;
			position: sticky;
			bottom: -30px;
			padding: 20px 0 50px;
			margin-top: -30px;
			background: #fff;
			
			.c-button {
				margin: 0 9px;
			}
		}
	}
</style>
